import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { CheckMark, Trash2Outline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseCheckbox, Box, LinkButton, Tooltip } from '@lyearn/ui';

import { checkboxStyles, deleteActionDisabledStyles } from './styles';

interface RenderOptionKeyCodeParams {
  t: TFunction;
  disabled?: boolean;
  optionEvaluation: boolean;
  onClick: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  isLocalizedContent?: boolean;
}

export const renderOptionKeyCode = (params: RenderOptionKeyCodeParams) => {
  const { disabled, optionEvaluation, t, isLocalizedContent } = params;

  if (disabled) {
    return (
      <Tooltip placement="left" title={t('QuizCreator:OptionEvaluationDisabled')!}>
        {renderEvaluationCheckbox(params)}
      </Tooltip>
    );
  }

  if (optionEvaluation) {
    return renderEvaluationCheckbox(params);
  }

  return (
    <Tooltip placement="left" title={t('QuizCreator:Markascorrect')!}>
      {renderEvaluationCheckbox(params)}
    </Tooltip>
  );
};

const renderEvaluationCheckbox = ({
  optionEvaluation,
  onClick,
  disabled,
  isLocalizedContent,
}: RenderOptionKeyCodeParams) => (
  <Box style={isLocalizedContent ? { pointerEvents: 'none' } : {}}>
    <BaseCheckbox
      checked={optionEvaluation}
      checkedIcon={<CheckMark className="h-20 w-20" />}
      className={cn(
        'h-24 w-24 rounded-4 border border-solid p-0 hover:bg-transparent',
        checkboxStyles,
      )}
      disabled={disabled}
      icon={<CheckMark className="h-20 w-20" />}
      onChange={onClick}
    />
  </Box>
);

interface RenderDeleteActionParams {
  className?: string;
  disabled?: boolean;
  onRemove: () => void;
}

export const renderDeleteAction = ({ className, onRemove, disabled }: RenderDeleteActionParams) => (
  <LinkButton
    className={cn(
      'py-2 px-4',
      'opacity-0',
      disabled ? deleteActionDisabledStyles : 'group-hover/option:opacity-100',
      className,
    )}
    disabled={disabled}
    onClick={onRemove}>
    <Trash2Outline className="text-icon-placeholder hover:text-icon-error" />
  </LinkButton>
);
